module.exports = __webpack_public_path__ + "img/down5-en.ac1e1759.png";